export default __webpack_public_path__ + "static/media/arrow_forward_black-2.0dfc2508.png";